import { SubscribePayloadType } from 'redux/actions/followersActions';
import { SearchFiltersType, SearchItemType, SearchRequestResultType, SearchStoreType } from 'types/nausearchType';
import { ActionType } from 'types/reduxTypes';
import { idOnly } from 'utils/cls.utils';
import { SearchResponseType, isSearchPeopleItem, responseToCorrectArray } from 'utils/search.utils';
import {
  CLEAR_SEARCH_DATA,
  GET_NAUSEARCH_ITEM,
  GET_NAUSEARCH_ITEM_FAILED,
  GET_NAUSEARCH_ITEM_SUCCESS,
  NAUSEARCH_REQUEST,
  NAUSEARCH_REQUEST_FAILED,
  NAUSEARCH_REQUEST_SUCCESS,
  RESET_SEARCH_FORM,
  SET_NAUSEARCH_ITEM,
  SET_NAUSEARCH_REQUEST_MESSAGE,
  SET_SEARCH_FORM,
  SUBSCRIBE_SUCCESS,
} from '../constants';

const initialState: SearchStoreType = {
  error: false,
  errorText: '',
  hasNextPage: false,
  loading: false,
  postData: {
    authors: [],
    document: '',
  },
  searchAfterIdSort: null,
  searchAfterScore: null,
  searchForm: {
    author: '',
    endPublicationDate: null,
    endYear: null,
    keywords: '',
    startPublicationDate: null,
    startYear: null,
  },
  searchItem: null,

  searchQueryMessage: '',
  searchResult: [],
  totalElements: 0,
};

export default (state = initialState, action: ActionType<unknown>): typeof initialState => {
  switch (action.type) {
    case CLEAR_SEARCH_DATA: {
      return {
        ...state,
        searchAfterIdSort: null,
        searchAfterScore: null,
        searchForm: initialState.searchForm,
        searchQueryMessage: '',
        searchResult: [],
      };
    }

    case SET_NAUSEARCH_REQUEST_MESSAGE: {
      const message = action.payload as string;
      return { ...state, searchQueryMessage: message };
    }

    case GET_NAUSEARCH_ITEM: {
      return { ...state, loading: true };
    }

    case GET_NAUSEARCH_ITEM_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case GET_NAUSEARCH_ITEM_SUCCESS: {
      const response = responseToCorrectArray([action.payload as unknown as SearchResponseType]);
      return { ...state, loading: false, postData: response[0] as typeof initialState.postData };
    }

    case NAUSEARCH_REQUEST: {
      const { isAddLoad } = action.payload as { isAddLoad?: boolean };
      return {
        ...state,
        error: false,
        errorText: '',
        loading: true,
        ...(isAddLoad
          ? {}
          : {
              hasNextPage: false,
              searchAfterIdSort: null,
              searchAfterScore: null,
              searchResult: [],
              totalElements: 0,
            }),
      };
    }

    case NAUSEARCH_REQUEST_FAILED: {
      return { ...state, error: true, errorText: action.payload as string, loading: false };
    }

    case NAUSEARCH_REQUEST_SUCCESS: {
      const result = action.payload as SearchRequestResultType;
      const { data, hasNextPage, searchAfterIdSort, searchAfterScore, isAddLoad, totalElements } = result;
      return {
        ...state,
        error: false,
        errorText: '',
        hasNextPage,
        loading: false,
        searchAfterIdSort: searchAfterIdSort,
        searchAfterScore: searchAfterScore,
        searchResult: isAddLoad
          ? [...(state.searchResult as SearchItemType[]), ...(data as SearchItemType[])]
          : (data as typeof initialState.searchResult),
        totalElements,
      };
    }

    case SET_NAUSEARCH_ITEM: {
      return { ...state, searchItem: action.payload as SearchStoreType['searchItem'] };
    }
    case SET_SEARCH_FORM: {
      const updatedForm = action.payload as SearchFiltersType;
      return {
        ...state,
        searchAfterIdSort: undefined,
        searchAfterScore: undefined,
        searchForm: {
          ...state.searchForm,
          ...updatedForm,
        },
      };
    }

    case RESET_SEARCH_FORM: {
      return {
        ...state,
        hasNextPage: false,
        searchAfterIdSort: null,
        searchAfterScore: null,
        searchForm: initialState.searchForm,
        searchResult: [],
        totalElements: 0,
      };
    }

    case SUBSCRIBE_SUCCESS: {
      const { userId, subscribed } = action.payload as SubscribePayloadType;

      return {
        ...state,
        searchResult: state.searchResult.map((item) => {
          if (!isSearchPeopleItem(item) || idOnly(item.entityInfo.rEntity) !== userId) {
            return item;
          }

          return {
            ...item,
            entityInfo: { ...item.entityInfo, subscribed: Boolean(subscribed) },
          };
        }),
      };
    }

    default: {
      return state;
    }
  }
};
